import { render } from "./CaseNavigation.vue?vue&type=template&id=39c910a6"
import script from "./CaseNavigation.vue?vue&type=script&lang=js"
export * from "./CaseNavigation.vue?vue&type=script&lang=js"

import "./CaseNavigation.vue?vue&type=style&index=0&id=39c910a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__